/* Admin Login Page Container */

import React, { useState, useEffect } from "react";
import axios from "../../axios";
import AdminLogin from "./AdminLogin";
import Footer from "../Common/Footer";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";

export default function AdminLoginPage(props) {
    const [oktaRedirectSettings, setOktaRedirectSettings] = useState(null);
    const [office365RedirectSettings, setOffice365RedirectSettings] = useState(null);
    const [isOktaConfigured, setIsOktaConfigured] = useState(null);
    const [isOffice365Configured, setIsOffice365Configured] = useState(null);
    const [requestPending, setRequestPending] = useState(false);

    const getOperatorInfo = () => {
        if (!requestPending) {
            setRequestPending(true);
            axios.post("/networkoperatorconsole/equipment/listOperatorDetails", {}, { headers: {} }).then(
                (response) => {
                    setRequestPending(false);
                    if (response.data.SignOn?.Cognito?.CognitoPool_IdentityProviders?.SAML?.okta) {
                        setIsOktaConfigured(true);
                        setOktaRedirectSettings({
                            cognitoHost: response.data.SignOn.Cognito.CognitoPool_Domain,
                            type: "authorize",
                            identity_provider: "okta",
                            response_type: "code",
                            clientId: response.data.SignOn.Cognito.CognitoPool_appclientid,
                            redirectUrl: response.data.RequestHeaderOrigin,
                            scope: "email openid profile",
                        });
                    }
                    if (response.data.SignOn?.Cognito?.CognitoPool_IdentityProviders?.SAML?.office365) {
                        setIsOffice365Configured(true);
                        setOffice365RedirectSettings({
                            cognitoHost: response.data.SignOn.Cognito.CognitoPool_Domain,
                            type: "authorize",
                            identity_provider: "office365",
                            response_type: "code",
                            clientId: response.data.SignOn.Cognito.CognitoPool_appclientid,
                            redirectUrl: response.data.RequestHeaderOrigin,
                            scope: "email openid profile",
                        });
                    }
                },
                (error) => {
                    setRequestPending(false);
                    console.log("Error fetching list operator details", error);
                }
            );
        }
    };

    const getOktaLoginURL = () => {
        if (oktaRedirectSettings) {
            return `${oktaRedirectSettings.cognitoHost}/oauth2/${oktaRedirectSettings.type}?identity_provider=${oktaRedirectSettings.identity_provider}&response_type=${oktaRedirectSettings.response_type}&client_id=${oktaRedirectSettings.clientId}&redirect_uri=${oktaRedirectSettings.redirectUrl}&scope=${oktaRedirectSettings.scope}`;
        }
    };

    const getOffice365LoginURL = () => {
        if (office365RedirectSettings) {
            return `${office365RedirectSettings.cognitoHost}/oauth2/${office365RedirectSettings.type}?identity_provider=${office365RedirectSettings.identity_provider}&response_type=${office365RedirectSettings.response_type}&client_id=${office365RedirectSettings.clientId}&redirect_uri=${office365RedirectSettings.redirectUrl}&scope=${office365RedirectSettings.scope}`;
        }
    };

    const oktaLoginHandler = () => {
        window.location.assign(getOktaLoginURL());
    };

    const office365LoginHandler = () => {
        window.location.assign(getOffice365LoginURL());
    };

    useEffect(() => {
        getOperatorInfo();
    }, []);

    return (
        <>
            <div className="Login FindDeals">
                <div className="logoMobile">
                    <img src={props.logoMobile} alt="Logo" />
                </div>
                <MDBContainer className="Form" fluid>
                    <MDBRow className="g-0 m-0">
                        <MDBCol sm="12" md="12" lg="12" className="ml-auto p-0">
                            <div className="Logo">
                                <img src={props.logoLogin} alt="Logo" />
                            </div>
                            <div className="topBanner">
                                <h2>Admin Login - {props.operatorName}</h2>
                            </div>
                            <div className="loginFormContainer">
                                <AdminLogin
                                    isOktaConfigured={isOktaConfigured}
                                    isOffice365Configured={isOffice365Configured}
                                    oktaLoginHandler={oktaLoginHandler}
                                    office365LoginHandler={office365LoginHandler}
                                    requestPending={requestPending}
                                />
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </div>
            {props.flagFooter ? <Footer /> : ""}
        </>
    );
}
